/* eslint-disable camelcase */
import { extend } from 'vee-validate';

extend('phone_format', {
  validate(value = '') {
    // Accept empty values for required validation to handle first
    if (!value) return true;

    // Remove all non-digit characters for validation
    const cleanValue = value.toString().replace(/\D+/g, '');

    // Convert 628 to 08 format for validation
    let normalizedValue = cleanValue;
    if (normalizedValue.startsWith('628')) {
      normalizedValue = normalizedValue.replace('628', '08');
    }

    return /^08/.test(normalizedValue);
  },
  message: 'Nomor handphone harus diawali dengan 08',
});

extend('phone_numeric', {
  validate(value = '') {
    // Accept empty values for required validation to handle first
    if (!value) return true;

    // Check if the value contains only digits after cleaning
    const cleanValue = value.toString().replace(/\D+/g, '');
    return (
      cleanValue.length === value.toString().length || /^\d+$/.test(cleanValue)
    );
  },
  message: 'Hanya dapat diisi dengan angka',
});

extend('phone_min', {
  validate(value = '', { length }) {
    // Accept empty values for required validation to handle first
    if (!value) return true;

    // Clean the value and check length
    const cleanValue = value.toString().replace(/\D+/g, '');

    // Convert 628 to 08 format for length validation
    let normalizedValue = cleanValue;
    if (normalizedValue.startsWith('628')) {
      normalizedValue = normalizedValue.replace('628', '08');
    }

    return normalizedValue.length >= parseInt(length);
  },
  params: ['length'],
  message: 'Minimal {length} karakter',
});

extend('phone_max', {
  validate(value = '', { length }) {
    // Accept empty values for required validation to handle first
    if (!value) return true;

    // Clean the value and check length
    const cleanValue = value.toString().replace(/\D+/g, '');

    // Convert 628 to 08 format for length validation
    let normalizedValue = cleanValue;
    if (normalizedValue.startsWith('628')) {
      normalizedValue = normalizedValue.replace('628', '08');
    }

    return normalizedValue.length <= parseInt(length);
  },
  params: ['length'],
  message: 'Maksimal {length} karakter',
});
